export enum AppointmentNotificationStatus {
  Pending = 0,
  Scheduled = 1,
  Sent = 2,
  Failed = 3,
  Cancelled = 4
}

export const AppointmentNotificationStatusLabels: Record<AppointmentNotificationStatus, string> = {
  [AppointmentNotificationStatus.Pending]: 'Pending',
  [AppointmentNotificationStatus.Scheduled]: 'Scheduled',
  [AppointmentNotificationStatus.Sent]: 'Sent',
  [AppointmentNotificationStatus.Failed]: 'Failed',
  [AppointmentNotificationStatus.Cancelled]: 'Cancelled'
};
